import { render, staticRenderFns } from "./RestoreIcon.vue?vue&type=template&id=5b99d7d1&scoped=true&"
import script from "./RestoreIcon.vue?vue&type=script&lang=js&"
export * from "./RestoreIcon.vue?vue&type=script&lang=js&"
import style0 from "./RestoreIcon.vue?vue&type=style&index=0&id=5b99d7d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b99d7d1",
  null
  
)

export default component.exports